import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import {createRoot} from 'react-dom/client';

import "./index.css";
import "./styles/Main.scss";

import App from "./App";
import * as serviceWorker from "./serviceWorker";
import {createEpicMiddleware} from "redux-observable";
import {applyMiddleware, createStore} from "redux";
import {composeWithDevTools} from "redux-devtools-extension";

import {Provider} from "react-redux";
import {rootEpic, rootReducer} from "reducers/rootReducer";
import {BrowserRouter} from "react-router-dom";

import * as Sentry from "@sentry/browser";
import { isProduction, sentryDsn } from "config";

// Browser-side error reporting: captures unhandled errors and the explicit
// captures in components (e.g. failed dashboard chart loads). A missing or
// invalid DSN disables reporting without affecting the app.
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: isProduction ? "production" : "development",
  });
  Sentry.setTag("app", "client-portal-ui");
}

const epicMiddleware = createEpicMiddleware();

const configureStore = () => {
  const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(epicMiddleware)));
  epicMiddleware.run(rootEpic);
  return store;
};

export const store = configureStore();
const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <App/>
    </Provider>
  </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
